angular.module('impactx.profile').controller('APITokenCreationCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'dataGen',
    'DownloadService',
    'TranslationService',
    'ToastService',
    '$copyToClipboard',
    APITokenCreationCtrl]);

function APITokenCreationCtrl($scope, $mdDialog, themeFactory, dataGen, DownloadService, TranslationService, ToastService, $copyToClipboard)
{
    dataGen.getData($scope, {}, "/apitoken/view").then(function () {
        $scope.trns.abortLabel = TranslationService.get("abort");
        $scope.trns.downloadLabel = TranslationService.get("download");
        $scope.trns.deleteLabel = TranslationService.get("delete");
    });

    this.save = function () {
        dataGen.postAsForm({}, {data: $scope.data}, "/apitoken/save").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $mdDialog.hide();
        });
    };

    this.abort = function () {
        $mdDialog.cancel();
    };

    this.downloadToken = function() {
        DownloadService.openDownloadPost("/apitoken/download/token", {});
    };

    this.deleteToken = function () {
        dataGen.postAsForm({}, {ids: [$scope.data.id]}, "/apitoken/delete").then(function () {
            ToastService.openStandardToast(TranslationService.get("deleteSuccess"));
            $mdDialog.hide();
        });
    };

    this.copyTokenToClipboard = function () {
        $copyToClipboard.copy($scope.data.apiToken.value).then(function () {
            ToastService.openStandardToast($scope.trns.copiedToClipboard);
        });
    };

    this.showDownloadButton = function () {
        return $scope.data.id > 0;
    };

    this.showDeleteButton = function () {
        return $scope.data.id > 0 && !$scope.data.isReadonly;
    };

    this.showSaveButton = function () {
        return !$scope.data.isReadonly;
    };
}